import { render, staticRenderFns } from "./XuqiuDialogTask.vue?vue&type=template&id=5b35c0af&scoped=true"
import script from "./XuqiuDialogTask.vue?vue&type=script&lang=js"
export * from "./XuqiuDialogTask.vue?vue&type=script&lang=js"
import style0 from "./XuqiuDialogTask.vue?vue&type=style&index=0&id=5b35c0af&prod&scoped=true&lang=css"
import style1 from "./XuqiuDialogTask.vue?vue&type=style&index=1&id=5b35c0af&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b35c0af",
  null
  
)

export default component.exports